import type { Form } from '../../../../common/types/form';
import type { ContactAttempt } from '../../../../common/types/client';

const contactAttemptForm: Form<ContactAttempt> = {
  key: 'contactAttempts',
  title: 'Kurzkontakte',
  fields: [
    {
      key: 'date',
      label: 'Datum',
      fieldTypes: 'date',
      xsWidth: 6,
    },
    {
      key: 'typeOfContact',
      label: 'Art der Kontaktaufnahme',
      fieldTypes: 'select',
      xsWidth: 6,
      options: [
        { value: 'byPhone', label: 'telefonisch' },
        { value: 'byPost', label: 'postalisch' },
        { value: 'sms', label: 'SMS' },
        { value: 'mail', label: 'E-Mail' },
        { value: 'messenger', label: 'Messenger' },
        { value: 'chat', label: 'Chat' },
        { value: 'videochat', label: 'Videochat' },
        { value: 'personally', label: 'persönlich' },
        { value: 'noContactPossible', label: 'keine Kontaktaufnahme möglich' },
      ],
    },
    {
      key: 'notice',
      label: 'Kommentar',
      rows: 5,
      fieldTypes: 'textArea',
    },
  ],
};

export default contactAttemptForm;
